import React from 'react';
import {IProps} from "./types";
import {COUNTRY} from "../../constants";

const ElementWithAccessInCountries = ({children, hideInCountries, ...props}: IProps ) =>
        !hideInCountries.includes(COUNTRY) && React.cloneElement(<>{children}</>, props) || null;

export default ElementWithAccessInCountries